import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { BUSINESS } from "../data/content";

export const WhatsAppFloat = () => (
  <motion.a
    href={BUSINESS.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with BHF Creative on WhatsApp"
    data-testid="floating-whatsapp-btn"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.1 }}
    className="fixed bottom-5 right-5 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1FBF59] text-[#06220f] shadow-[0_8px_32px_rgba(37,211,102,0.4)] no-underline"
  >
    <MessageCircle size={26} />
  </motion.a>
);
